import { render, staticRenderFns } from "./ProjectBanner.vue?vue&type=template&id=b27c360e&"
import script from "./ProjectBanner.vue?vue&type=script&lang=js&"
export * from "./ProjectBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports